import 'babel-polyfill';
import initializeBrowserHistoryListener from './initializeBrowserHistoryListener';
import store from './redux/configureSearchUnitStore';
import initialize from './initialize';
import routesSearchUnit from './routes/searchUnit';
import bootstrapApp from './bootstrapApp';

initialize(store);
bootstrapApp(routesSearchUnit, store);

initializeBrowserHistoryListener(store, {
  isUpdateWebtrendsEnabled: false,
});



/** WEBPACK FOOTER **
 ** ./src/mainSearchUnit.js
 **/